import {
    EUROPACE_INSURED_RISKS,
    LOAN_REQUEST_OFFER_BANKS,
    LOAN_REQUEST_OFFER_STATUS,
    LOAN_REQUEST_USAGES,
    OFFER_ACCEPTANCE_STATUSES,
} from 'cpool-constants';
import { z } from 'zod';

import { schemaApplicantAttributionBoth, schemaBigDecimal } from '../../utils/schema.utils';

export const schemaManualOffer = z.object({
    acceptanceStatus: z.literal(OFFER_ACCEPTANCE_STATUSES.SUCCESS),
    acceptedAt: z.number().nullable(),
    applicant1ResidualDebtInsurance: z.array(z.nativeEnum(EUROPACE_INSURED_RISKS)).optional(),
    applicant2ResidualDebtInsurance: z.array(z.nativeEnum(EUROPACE_INSURED_RISKS)).optional(),
    // Which applicant(s) this offer is for; nullish so pre-existing historical events without this field still replay.
    applicantAttribution: schemaApplicantAttributionBoth.nullish(),
    bank: z.nativeEnum(LOAN_REQUEST_OFFER_BANKS),
    commissionResponseInPercent: z.optional(schemaBigDecimal),
    creditAmount: z.number().nullable(),
    file: z
        .object({
            fileExtension: z.string().optional(),
            key: z.string().min(1),
            mimeType: z.string().min(1),
            name: z.string().min(1),
        })
        .optional(),
    financingPurpose: z.nativeEnum(LOAN_REQUEST_USAGES).nullish(),
    id: z.string().min(1),
    interest: z.number().nullable(),
    providerApplicationNumber: z.string().nullish(),
    rate: z.number().nullable(),
    runtime: z.number().nullable(),
    status: z.nativeEnum(LOAN_REQUEST_OFFER_STATUS),
});

export type SchemaManualOffer = z.infer<typeof schemaManualOffer>;
